import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import AdminPageLayout from "../../../components/midpoint/admin/layout/AdminPageLayout";
import AdminPageHeader from "../../../components/midpoint/admin/layout/AdminPageHeader";
import { AdminAutomotiveNav } from "../automotive/AdminAutomotiveNav";
import {
  PARTNER_LEAD_STATUS_LABELS,
  getCategoryLabel,
} from "../../../constants/automapPartnershipConstants";
import {
  addPartnerLeadNote,
  deliverPartnerLead,
  fetchPartnerLead,
  routePartnerLead,
  updatePartnerLeadStatus,
} from "../../../services/automapPartnershipApi";
import { AdminPartnersNav } from "./AdminPartnersShared";

export default function AdminPartnerLeadDetailPage() {
  const { leadId } = useParams();
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [note, setNote] = useState("");
  const [copied, setCopied] = useState(false);

  const load = () => {
    setLoading(true);
    fetchPartnerLead(leadId)
      .then(setDetail)
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load();
  }, [leadId]);

  const lead = detail?.lead;

  const setStatus = async (status, extra = {}) => {
    await updatePartnerLeadStatus(leadId, { status, ...extra });
    load();
  };

  const handleDeliver = async () => {
    const res = await deliverPartnerLead(leadId);
    if (res.deliverySummary) {
      await navigator.clipboard.writeText(res.deliverySummary).catch(() => {});
      setCopied(true);
    }
    load();
  };

  const handleRoute = async () => {
    await routePartnerLead(leadId);
    load();
  };

  const handleNote = async () => {
    if (!note.trim()) return;
    await addPartnerLeadNote(leadId, { body: note.trim(), noteType: "general" });
    setNote("");
    load();
  };

  return (
    <AdminPageLayout>
      <AdminPageHeader eyebrow="AutoMapa · Lead aliado" title={lead?.buyerName || "Lead"} />
      <AdminAutomotiveNav active="partners" />
      <AdminPartnersNav />
      <main className="admin-console__main wrap">
        {loading ? <p>Cargando…</p> : null}
        {lead ? (
          <>
            <section className="dealer-state-box">
              <p><strong>Categoría:</strong> {getCategoryLabel(lead.category)}</p>
              <p><strong>Estado:</strong> {PARTNER_LEAD_STATUS_LABELS[lead.status]}</p>
              <p><strong>Aliado:</strong> {lead.partnerName}</p>
              <p><strong>WhatsApp:</strong> {lead.buyerWhatsapp || "—"} · <strong>Email:</strong> {lead.buyerEmail || "—"}</p>
              <p><strong>Ciudad:</strong> {lead.buyerCity || "—"}</p>
              <p><strong>Vehículo:</strong> {lead.vehicleLabel}</p>
              <p><strong>Listing:</strong> {lead.listingId || "—"} · <strong>Dealer:</strong> {lead.dealerId || "—"}</p>
              <p><strong>Origen:</strong> {lead.sourcePage} / {lead.sourceComponent} / {lead.sourceAction}</p>
              <p><strong>Consentimiento:</strong> {lead.consentAccepted ? "Sí" : "No"} · <strong>Divulgación:</strong> {lead.disclosureAccepted ? "Sí" : "No"}</p>
              {lead.buyerMessage ? <p><strong>Mensaje:</strong> {lead.buyerMessage}</p> : null}
            </section>
            <section className="dealer-state-box">
              <h3>Acciones</h3>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem" }}>
                {!lead.partnerId ? <button type="button" className="dealer-portal-btn" onClick={handleRoute}>Enrutar</button> : null}
                <button type="button" className="dealer-portal-btn" onClick={handleDeliver}>Marcar entregado y copiar resumen</button>
                <button type="button" className="dealer-portal-btn" onClick={() => setStatus("contacted")}>Contactado</button>
                <button type="button" className="dealer-portal-btn" onClick={() => setStatus("qualified")}>Calificado</button>
                <button type="button" className="dealer-portal-btn" onClick={() => setStatus("converted")}>Convertido</button>
                <button type="button" className="dealer-portal-btn" onClick={() => setStatus("lost", { lostReason: "not_interested" })}>Perdido</button>
              </div>
              {copied ? <p className="muted">Resumen copiado al portapapeles.</p> : null}
              {detail.deliverySummary ? (
                <pre style={{ whiteSpace: "pre-wrap", fontSize: "0.85rem", marginTop: "1rem" }}>{detail.deliverySummary}</pre>
              ) : null}
            </section>
            <section className="dealer-state-box">
              <h3>Timeline</h3>
              <ul>{(detail.events || []).map((e) => (
                <li key={e.id}>{new Date(e.createdAt).toLocaleString("es-CO")} — {e.eventType}: {e.description}</li>
              ))}</ul>
            </section>
            <section className="dealer-state-box">
              <h3>Notas</h3>
              <textarea rows={2} value={note} onChange={(e) => setNote(e.target.value)} />
              <button type="button" className="dealer-portal-btn" onClick={handleNote}>Agregar nota</button>
              <ul>{(detail.notes || []).map((n) => <li key={n.id}>{n.body}</li>)}</ul>
            </section>
            <Link to="/admin/leads?tab=partner">← Volver a leads</Link>
          </>
        ) : null}
      </main>
    </AdminPageLayout>
  );
}
